
const ReadyToPlayActionSection = () => {
  return (
    <div 
      className="elementor-element elementor-element-cff84ff e-flex e-con-boxed e-con e-parent" 
      data-id="cff84ff" 
      data-element_type="container" 
      data-settings='{"background_background":"classic"}'
    >
      <div className="e-con-inner">
        {/* Título Chamada para Ação */}
        <div 
          className="elementor-element elementor-element-100ead7 elementor-widget elementor-widget-heading" 
          data-id="100ead7" 
          data-element_type="widget" 
          data-widget_type="heading.default"
        >
          <div className="elementor-widget-container">
            <h2 className="elementor-heading-title elementor-size-default">
              Pronto para Jogar? Escolha o Seu Casino!
            </h2>
          </div>
        </div>

        {/* Texto Descritivo */}
        <div 
          className="elementor-element elementor-element-d4f9754 elementor-widget__width-initial elementor-widget elementor-widget-text-editor" 
          data-id="d4f9754" 
          data-element_type="widget" 
          data-widget_type="text-editor.default"
        >
          <div className="elementor-widget-container">
            Explore a nossa tabela comparativa detalhada para encontrar a melhor opção para si. 
            Seja você procurar o maior bónus de boas-vindas, a melhor seleção de jogos ou os 
            métodos de pagamento mais fáceis, temos tudo o que precisa.
          </div>
        </div>

        {/* Botão de Comparação */}
        <div 
          className="elementor-element elementor-element-ad4fabe elementor-align-center elementor-widget elementor-widget-button" 
          data-id="ad4fabe" 
          data-element_type="widget" 
          data-widget_type="button.default"
        >
          <div className="elementor-widget-container">
            <div className="elementor-button-wrapper">
              <a className="elementor-button elementor-button-link elementor-size-sm" href="#compare">
                <span className="elementor-button-content-wrapper">
                  <span className="elementor-button-text">Comparar Agora</span>
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReadyToPlayActionSection;